// // src/contexts/AuthContext.jsx
// import { createContext, useContext, useEffect, useState } from 'react';

// const AuthContext = createContext();

// export function AuthProvider({ children }) {
//   const [userInfo, setUserInfo] = useState(null);

//   useEffect(() => {
//     const storedUser = localStorage.getItem('userInfo');
//     if (storedUser) {
//       setUserInfo(JSON.parse(storedUser));
//     }
//   }, []);

//   const login = (user) => {
//     localStorage.setItem('userInfo', JSON.stringify(user));
//     setUserInfo(user);
//   };

//   const logout = () => {
//     localStorage.removeItem('userInfo');
//     setUserInfo(null);
//   };

//   return (
//     <AuthContext.Provider value={{ userInfo, login, logout, isAuthenticated: !!userInfo }}>
//       {children}
//     </AuthContext.Provider>
//   );
// }

// export function useAuth() {
//   return useContext(AuthContext);
// }


// import { createContext, useContext, useEffect, useState } from 'react';

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [userInfo, setUserInfo] = useState(null);
//   const [loading, setLoading] = useState(true); // prevent flicker on refresh

//   useEffect(() => {
//     const storedUser = localStorage.getItem('userInfo');
//     if (storedUser) {
//       setUserInfo(JSON.parse(storedUser));
//     }
//     setLoading(false); // hydration complete
//   }, []);

//   const login = (user) => {
//     localStorage.setItem('userInfo', JSON.stringify(user));
//     setUserInfo(user);
//   };

//   const logout = () => {
//     localStorage.removeItem('userInfo');
//     setUserInfo(null);
//   };

//   return (
//     <AuthContext.Provider
//       value={{
//         userInfo,
//         login,
//         logout,
//         isAuthenticated: !!userInfo
//       }}
//     >
//       {/* prevent rendering children until hydration is done */}
//       {loading ? <div>Loading...</div> : children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);







import { createContext, useContext, useEffect, useState, useRef } from 'react';

const AuthContext = createContext();
const IDLE_TIMEOUT = 5 * 60 * 1000; // 10 minutes in milliseconds
// const IDLE_TIMEOUT = 5 * 1000; 
export const AuthProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const idleTimer = useRef(null);

  // Check localStorage for existing user info
  useEffect(() => {
    const storedUser = localStorage.getItem('userInfo');
    if (storedUser) {
      setUserInfo(JSON.parse(storedUser));
      startIdleTimer(); // Start timer only if user is logged in
    }
    setLoading(false);
  }, []);

  // Function to start/reset idle timer
  const startIdleTimer = () => {
    clearIdleTimer(); // clear previous timer if exists
    idleTimer.current = setTimeout(() => {
      handleLogoutDueToInactivity();
    }, IDLE_TIMEOUT);
  };

  const clearIdleTimer = () => {
    if (idleTimer.current) {
      clearTimeout(idleTimer.current);
      idleTimer.current = null;
    }
  };

  const handleUserActivity = () => {
    if (userInfo) startIdleTimer(); // only track if logged in
  };

  // Attach activity listeners
  useEffect(() => {
    const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'];
    events.forEach((event) => window.addEventListener(event, handleUserActivity));

    return () => {
      events.forEach((event) => window.removeEventListener(event, handleUserActivity));
      clearIdleTimer();
    };
  }, [userInfo]);

  const login = (user) => {
    localStorage.setItem('userInfo', JSON.stringify(user));
    setUserInfo(user);
    startIdleTimer();
  };

  const logout = () => {
    localStorage.removeItem('userInfo');
    setUserInfo(null);
    clearIdleTimer();
  };

  const handleLogoutDueToInactivity = () => {
    alert('You have been logged out due to inactivity.');
    logout();
  };

  return (
    <AuthContext.Provider
      value={{
        userInfo,
        login,
        logout,
        isAuthenticated: !!userInfo
      }}
    >
      {loading ? <div>Loading...</div> : children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
